import type { NewsletterSignupBlockContent } from "../types"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Textarea } from "@/components/ui/textarea"
import { Card, CardContent, CardHeader } from "@/components/ui/card"

interface NewsletterSignupBlockEditorProps {
  content: NewsletterSignupBlockContent | null
  onChange: (content: NewsletterSignupBlockContent) => void
}

export function NewsletterSignupBlockEditor({
  content,
  onChange,
}: NewsletterSignupBlockEditorProps) {
  const c = content ?? {}
  const update = (partial: Partial<NewsletterSignupBlockContent>) =>
    onChange({ ...c, ...partial })

  return (
    <Card>
      <CardHeader>
        <h3 className="text-base font-medium">Newsletter Signup</h3>
      </CardHeader>
      <CardContent className="space-y-4">
        <div>
          <Label>Heading</Label>
          <Input
            value={c.heading ?? ""}
            onChange={(e) => update({ heading: e.target.value })}
            placeholder="Subscribe to our newsletter"
          />
        </div>
        <div>
          <Label>Body</Label>
          <Textarea
            value={c.body ?? ""}
            onChange={(e) => update({ body: e.target.value })}
            placeholder="Brief description"
            rows={2}
            className="resize-none"
          />
        </div>
        <div>
          <Label>CTA Text</Label>
          <Input
            value={c.cta_text ?? ""}
            onChange={(e) => update({ cta_text: e.target.value })}
            placeholder="Subscribe"
          />
        </div>
        <div>
          <Label>Placeholder</Label>
          <Input
            value={c.placeholder ?? ""}
            onChange={(e) => update({ placeholder: e.target.value })}
            placeholder="Enter your email"
          />
        </div>
      </CardContent>
    </Card>
  )
}
